import { useTranslation } from 'react-i18next'

import { formatPrice } from '@/lib/format'

import { ActionButtonsWrapper, CancelButton, PayButton } from './ActionButtons.styles'

const ActionButtons = ({ total, currency, onPay, onCancel }) => {
  const { t } = useTranslation()

  return (
    <ActionButtonsWrapper>
      <CancelButton onClick={onCancel}>{t('cartPanel.cancel')}</CancelButton>
      <PayButton onClick={onPay}>{t('cartPanel.pay', { amount: formatPrice(total, currency) })}</PayButton>
    </ActionButtonsWrapper>
  )
}

export default ActionButtons
